import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {setErrors, setModel} from "features/model/slice/create-test/add-test/responseAddTest";

interface TestFormData {
    title: string;
    available: string;
    selectedGroupIds: number[];
    selectedStudentIds: number[];
}

export const fetchAddTest = createAsyncThunk(
    'test/addTest',
    async (requestData: TestFormData, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                return thunkAPI.rejectWithValue('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.post(
                '/api/tests',
                requestData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                thunkAPI.dispatch(setModel(response.data.model));
                return response.data;
            }

            thunkAPI.dispatch(setErrors(response.data));
            return thunkAPI.rejectWithValue(
                response.data.error || response.data.errors || 'Ошибка создания теста.'
            );
        } catch (error: any) {
            const payload = error?.response?.data;
            if (payload) {
                thunkAPI.dispatch(setErrors(payload));
            }
            return thunkAPI.rejectWithValue(
                payload?.error || payload?.errors || error?.message || 'Ошибка создания теста.'
            );
        }
    }
);
